import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { paths } from '../../../../routing/path';

export interface MyTeamMembersMenuItemProps {
    className?: string;
    marginLeft?: number;
}

export const MyTeamMembersMenuItem = (props: MyTeamMembersMenuItemProps) => (
    <LeftMenuItem
        icon="pe-7s-add-user"
        label="My Team Members"
        to={paths.account.associates}
        className={props.className}
        marginLeft={props.marginLeft}
        trackingAction="My Team Members"
    />
);
